import {
  Modal,
  Fade,
  makeStyles,
  Grid,
  Dialog,
  AppBar,
  Toolbar,
  Slide,
  Typography,
  IconButton,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React, { useContext, useEffect } from "react";
import AddGroupModal from "./AddGroupModal";
import FilterModal from "./FilterModal";
import MapModal from "./MapModal";
import { useTranslation } from "react-i18next";
import { AuthUserContext } from "../Session";
import { hasPermission } from "../../functions/authorization";
import { GROUPS_ADD } from "../../constants/roles";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const GroupsModals = (props) => {
  const classes = useStyles();
  const { open, handleClose, type } = props;
  const { t } = useTranslation();
  const authUser = useContext(AuthUserContext);

  const canAddGroup = hasPermission(authUser, GROUPS_ADD);

  useEffect(() => {
    if (open && type === "add" && !canAddGroup) {
      handleClose(false);
    }
  }, [open, type, canAddGroup, handleClose]);

  if (type === "add") {
    if (!canAddGroup) {
      return null;
    }

    return (
      <Dialog fullScreen open={open} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={() => handleClose(false)} aria-label="close">
              <Close />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              {t("groups.new.title.add")}
            </Typography>
          </Toolbar>
        </AppBar>

        <Grid container justifyContent="center">
          <Grid item xs={12} lg={8}>
            <AddGroupModal {...props} />
          </Grid>
        </Grid>
      </Dialog>
    );
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={open}
      onClose={() => handleClose(false)}
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open} unmountOnExit>
        <Grid container justify="center" alignItems="center">
          {type === "map" && <MapModal {...props} />}
          {type === "filter" && <FilterModal {...props} />}
        </Grid>
      </Fade>
    </Modal>
  );
};

export default GroupsModals;

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
  },
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));